


































































































































































































































import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
  nextTick,
  PropType,
  useContext,
  useRouter,
  useRoute,
  watch,
  onBeforeMount
} from '~/utils/nuxt3-migration'
import vClickOutside from 'v-click-outside'
import { ciMagnifyingGlass } from '~/icons/source/regular/magnifying-glass'
import { ciTimes } from '~/icons/source/regular/times'
import { useI18n } from '~/compositions/i18n'
import SearchbarService from '~/services/search-bar/SearchbarService'
import { useDeps } from '~/compositions/dependency-container'
import { elementIsOverflownInParent } from '~/utils/dom'
import ScrollService from '~/services/scroll/ScrollService'
import { CategoryId } from '~/models/category/types'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SLOW } from '~/constants/debounce'
import { KeyCode } from '~/constants/keyboard'
import { useUserAgent } from '~/compositions/user-agent'
import { useModalToggle } from '~/compositions/modal-toggle'
import CMicrophoneRecorder from '~/components/shared/configurable/CMicrophoneRecorder.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import qs from 'qs'
import { isCancelError } from '~/utils/http'
import { useLogger } from '~/compositions/logger'
import {
  SmartAction,
  SmartActionResult,
  SmartAutocompleteResult,
  SmartAutocompletion,
  SmartClassifiedResult,
  SmartInsightResult,
  SmartResultSection
} from '~/models/search-bar'
import SmartSearchbarAutocompleteSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarAutocompleteSuggestion.vue'
import SmartSearchbarActionSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarActionSuggestion.vue'
import SmartSearchbarClassifiedSuggestion from '~/components/shared/classified/search/searchbar/smart-suggestions/SmartSearchbarClassifiedSuggestion.vue'
import SmartSearchbarResultSection from '~/components/shared/classified/search/searchbar/SmartSearchbarResultSection.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import SearchbarInCategoryButtons from '~/components/shared/classified/search/searchbar/SearchbarInCategoryButtons.vue'
import { ciAngleLeft } from '~/icons/source/light/angle-left'
import { CLEAR_ALL } from '~/store/modules/shared/classifieds/search/mutation-types'
import { useSnackbar } from '~/compositions/snackbar'
import CExternalLinkMediatorModal from '~/components/shared/configurable/modal/CExternalLinkMediatorModal.vue'

export default defineComponent({
  components: {
    CExternalLinkMediatorModal,
    SearchbarInCategoryButtons,
    SmartSearchbarResultSection,
    SmartSearchbarClassifiedSuggestion,
    SmartSearchbarActionSuggestion,
    SmartSearchbarAutocompleteSuggestion,
    CMicrophoneRecorder
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      required: false,
      default: 150
    },
    forceCategory: {
      type: Number as PropType<CategoryId>,
      required: false,
      default: undefined
    },
    onlyUnderCategory: {
      type: Number as PropType<CategoryId>,
      required: false,
      default: undefined
    },
    actionsOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    notInSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    actionType: {
      type: String,
      required: false,
      default: undefined
    }
  },
  setup(props, { emit }) {
    const hasMic = ref(false)
    const focused = ref(false)
    const silentlyFocused = ref(false)
    const activePlaceholder = ref(0)
    const micRecording = ref(false)
    const activeQ = ref('')
    const searchQ = ref('')
    const activeDisplayPhrase = ref('')
    const linkToNavigate = ref('')
    const rightColumnIndexToNavigate = ref(-1)
    const classifiedIndexToNavigate = ref(-1)
    const classifiedClickEvent = ref(null)
    const fadePlaceholder = ref(false)
    const dontFetchNextInput = ref(false)
    const dontFetchNextFocus = ref(false)
    const fetchingAutocomplete = ref(false)
    const fetchingActions = ref(false)
    const fetchingClassifieds = ref(false)
    const fetchingInsight = ref(false)
    const fullscreen = ref(false)
    const suggestAfterFetch = ref(false)
    const cancelGuard = ref(false)
    const activeSuggestionIndex = ref(-1)
    const hoveredSuggestion = ref(-1)
    const placeholderInterval = ref(null)
    const activeSuggestion = ref(null)
    const inCategory = ref(!props.notInSearch)
    const backendPlaceholders = ref<string[]>([])
    const autocompleteSuggestions = ref<SmartAutocompleteResult[]>([])
    const actionSuggestions = ref<SmartActionResult[]>([])
    const classifiedSuggestions = ref<SmartClassifiedResult[]>([])
    const insightSuggestions = ref<SmartInsightResult[]>([])
    const leftColumnRefs = ref<
      (InstanceType<typeof SmartSearchbarResultSection> | null)[]
    >([])
    const rightColumnRefs = ref<
      (InstanceType<typeof SmartSearchbarResultSection> | null)[]
    >([])
    const searchbarRef = ref(null)
    const suggestionsRef = ref(null)
    const overflowContainerRef = ref(null)
    const externalLinkMediatorUrl = ref('')

    const { t } = useI18n()
    const router = useRouter()
    const logger = useLogger()
    const route = useRoute()
    const snackbar = useSnackbar()
    const { isMobile } = useUserAgent()
    const [searchbarService, scrollService] = useDeps(
      SearchbarService,
      ScrollService
    )
    const modalToggleFunc = useModalToggle()

    const { $cache: cache, store } = useContext()

    const {
      state: classifiedSearchState,
      getters: classifiedSearchGetters,
      dispatch: classifiedSearchDispatch
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)

    watch(fullscreen, val => {
      emit('fullscreen-state', val)
    })

    const getSetting = classifiedSearchGetters('getSetting')

    function onBeforeMountCalls() {
      const routeQ = route.value.query.activeq || route.value.query.q

      activeQ.value = routeQ || ''
      searchQ.value = routeQ || ''
      activeDisplayPhrase.value = routeQ || ''
    }

    onBeforeMount(() => {
      onBeforeMountCalls()
    })

    const qFacet = computed(() => classifiedSearchGetters('getQFacet'))

    const inSearchRoute = computed(() => {
      return (
        route.value.name?.startsWith('__classifieds_search') ||
        getSetting('isDealerSiteSearch')
      )
    })

    const context = computed(() => {
      if (
        inSearchRoute.value &&
        classifiedSearchState.currentRoute?.query?.myclassifieds
      ) {
        return 'myclassifieds'
      }
      return undefined
    })

    const searchId = computed(() => {
      if (!props.notInSearch) {
        return classifiedSearchState.searchId
      }
      return undefined
    })

    const clickedOutside = () => {
      if (fullscreen.value) {
        disableFullscreen()
      }
      closeSuggestions()
    }

    const focusSearchbar = async () => {
      await nextTick()
      if (searchbarRef.value) {
        searchbarRef.value.focus()
      }
    }

    const onEnter = async () => {
      if (activeSuggestionIndex.value >= 0) {
        const item = navigableItems.value[activeSuggestionIndex.value]
        if (item) {
          switch (item.type) {
            case 'action':
              onActionClick(item.suggestion)
              break
            case 'autocomplete':
              onAutocompletionClick(item.suggestion)
              break
            case 'classified':
              triggerClassifiedAtIndex(item.sectionIndex, item.index)
              break
          }
          blurSearchbar()
          return
        }
      }

      dontFetchNextInput.value = true
      await closeSuggestions()
      if (activeDisplayPhrase.value !== '') {
        suggestActiveDisplayPhrase()
      }
      blurSearchbar()

      if (activeDisplayPhrase.value === '' && fullscreen.value) {
        // if active display phrase is not empty, fullscreen will be disabled by goToUrl
        disableFullscreen()
      }
    }

    const suggestActiveDisplayPhrase = async () => {
      if (activeDisplayPhrase.value) {
        if (fetchingActions.value) {
          // we are already fetching a query so when this is finished
          suggestAfterFetch.value = true
        } else {
          try {
            suggestAfterFetch.value = true
            cancelGuard.value = false
            await fetchActionSuggestions(activeDisplayPhrase.value)
          } catch (error) {
            logger.captureError(error)
          } finally {
            suggestAfterFetch.value = false
          }
        }
      }
    }

    const leftColumnSections = computed<SmartResultSection[]>(() => {
      let formattedActions = []
      if (!fetchingActions.value) {
        formattedActions = actionSuggestions.value.map(
          (action: SmartActionResult) => {
            return {
              title: action.title || '',
              type: 'action',
              suggestions: action.actions,
              fetching: fetchingActions.value,
              tags: action.tags || []
            }
          }
        )
      }

      let formattedAutocompletes = []
      if (!fetchingAutocomplete.value) {
        formattedAutocompletes = autocompleteSuggestions.value.map(
          (autocomplete: SmartAutocompleteResult) => {
            return {
              title: autocomplete.title || '',
              type: 'autocomplete',
              suggestions: autocomplete.completions,
              fetching: fetchingAutocomplete.value,
              tags: autocomplete.tags || []
            }
          }
        )
      }

      let formattedInsights = []
      if (
        (!fullscreen.value &&
          !fetchingAutocomplete.value &&
          formattedAutocompletes.length) ||
        (!fetchingActions.value && formattedActions.length)
      ) {
        formattedInsights = insightSuggestions.value.map(
          (insight: SmartInsightResult) => {
            return {
              title: insight.title || '',
              type: 'insight',
              suggestions: [],
              content: insight.content,
              fetching: fetchingInsight.value,
              tags: insight.tags || []
            }
          }
        )
      }

      return [
        ...formattedActions,
        ...formattedAutocompletes,
        ...formattedInsights
      ]
    })

    const rightColumnSections = computed<SmartResultSection[]>(() => {
      let formattedClassifieds = []
      if (!fetchingClassifieds.value) {
        formattedClassifieds = classifiedSuggestions.value.map(
          (classified: SmartClassifiedResult) => {
            return {
              title: classified.title || '',
              type: 'classified',
              suggestions: classified.classifieds,
              fetching: fetchingClassifieds.value,
              tags: classified.tags || []
            }
          }
        )
      }

      let formattedInsights = []
      if (
        (leftColumnSections.value.length === 0 || fullscreen.value) &&
        !fetchingClassifieds.value &&
        formattedClassifieds.length
      ) {
        formattedInsights = insightSuggestions.value.map(
          (insight: SmartInsightResult) => {
            return {
              title: insight.title || '',
              type: 'insight',
              suggestions: [],
              content: insight.content,
              fetching: fetchingInsight.value,
              tags: insight.tags || []
            }
          }
        )
      }

      return [...formattedClassifieds, ...formattedInsights]
    })

    const currentCategoryId = computed(
      () => classifiedSearchState?.category?.id
    )

    const selectedCategory = computed(() => {
      if (inCategory.value && currentCategoryId.value) {
        return currentCategoryId.value
      }
      return props.forceCategory || undefined
    })
    const searchbarPlaceholder = computed(() => {
      return props.placeholder || t('what are you looking for?')
    })

    const placeholders = computed(() => {
      return [searchbarPlaceholder.value, ...backendPlaceholders.value]
    })

    const placeholderToShow = computed(() => {
      if (micRecording.value) {
        return t('start talking') + '...'
      }

      if (placeholders.value.length > 1) {
        const indexToShow =
          focused.value && !silentlyFocused.value ? 0 : activePlaceholder.value
        const prefix = indexToShow > 0 ? `${t('e.g.').toLowerCase()} ` : ''
        return prefix + placeholders.value[indexToShow]
      }

      return searchbarPlaceholder.value
    })

    const fetching = computed(() => {
      return (
        fetchingAutocomplete.value ||
        fetchingActions.value ||
        fetchingInsight.value ||
        fetchingClassifieds.value
      )
    })

    const showResults = computed(() => {
      return Boolean(hasLeftColumn.value || hasRightColumn.value)
    })

    const setFinalQuote = async q => {
      if (q) {
        micRecording.value = false
        activeQ.value = q
        await nextTick()
        onInput()
      }
    }
    const setInterimQuote = async q => {
      if (q) {
        activeQ.value = q
        await nextTick()
        onInput()
      }
    }
    const setMicRecStatus = (status: boolean) => {
      micRecording.value = status
    }

    const onInput = () => {
      // acts like vmodel but also works on mobile when input is changing
      activeQ.value = searchbarRef.value.value
      searchQ.value = activeQ.value as string
      activeDisplayPhrase.value = activeQ.value
      triggerAutocomplete()
    }

    const triggerAutocomplete = debounce(async () => {
      if (dontFetchNextInput.value) {
        dontFetchNextInput.value = false
      } else {
        await closeSuggestions()
        fetchSuggestions(searchQ.value)
      }
    }, DEBOUNCE_SLOW)

    const closeSuggestions = async () => {
      if (fetching.value) {
        cancelGuard.value = true
        await searchbarService.cancelRequests()

        // they just got cancelled and for some reason 'finally' does not run instantly after cancel
        fetchingAutocomplete.value = false
        fetchingActions.value = false
        fetchingInsight.value = false
        fetchingClassifieds.value = false

        cache.reset()
      }

      activeSuggestion.value = null
      if (autocompleteSuggestions.value.length) {
        autocompleteSuggestions.value = []
      }

      if (actionSuggestions.value.length) {
        actionSuggestions.value = []
      }
      if (classifiedSuggestions.value.length) {
        classifiedSuggestions.value = []
      }

      activeSuggestionIndex.value = -1
      hoveredSuggestion.value = -1
      emit('suggestions-close', activeQ.value)
    }

    const fetchSuggestions = async (q: string) => {
      if (cancelGuard.value) {
        cancelGuard.value = false
      }
      fetchAutocompleteSuggestions(q)
      fetchingClassifieds.value = true // to trigger the shimmers
      await fetchActionSuggestions(q)
      fetchClassifiedSuggestions(q)
      fetchInsightSuggestions(q)
    }

    const fetchAutocompleteSuggestions = async (q: string) => {
      try {
        if (cancelGuard.value || props.actionsOnly) {
          return
        }
        fetchingAutocomplete.value = true

        const suggestions = await searchbarService.getSmartAutocompleteSuggestions(
          q,
          selectedCategory.value,
          context.value,
          searchId.value
        )

        if (autocompleteSuggestions.value.length) {
          autocompleteSuggestions.value = []
        }
        activeSuggestionIndex.value = -1
        hoveredSuggestion.value = -1

        autocompleteSuggestions.value = suggestions
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingAutocomplete.value = false
      }
    }

    const fetchActionSuggestions = async (q: string) => {
      if (fetchingActions.value || cancelGuard.value) {
        return
      }
      try {
        if (!suggestAfterFetch.value) {
          fetchingActions.value = true
        }

        const actions = await searchbarService.getSmartActionSuggestions(
          q,
          selectedCategory.value,
          context.value,
          searchId.value,
          props.actionType,
          props.onlyUnderCategory
        )

        if (suggestAfterFetch.value) {
          await nextTick()
          // suggestAfterFetch.value = false
          if (actions.length && actions[0].actions.length) {
            onActionClick(actions[0].actions[0])
          } else {
            snackbar.error(t('no_results_for_this_term'))
          }
        } else {
          actionSuggestions.value = actions
          // backend requested to refetch classifieds here
          // fetchClassifiedSuggestions(q)
        }
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingActions.value = false
      }
    }

    const fetchClassifiedSuggestions = async (q: string) => {
      try {
        if (suggestAfterFetch.value || cancelGuard.value || props.actionsOnly) {
          return
        }
        fetchingClassifieds.value = true

        const suggestions = await searchbarService.getSmartClassifiedSuggestions(
          q,
          selectedCategory.value,
          context.value,
          searchId.value
        )

        if (classifiedSuggestions.value.length) {
          classifiedSuggestions.value = []
        }

        classifiedSuggestions.value = suggestions
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingClassifieds.value = false
      }
    }

    const fetchInsightSuggestions = async (q: string) => {
      try {
        if (suggestAfterFetch.value || cancelGuard.value || props.actionsOnly) {
          return
        }
        fetchingInsight.value = true

        if (insightSuggestions.value.length) {
          insightSuggestions.value = []
        }

        const suggestions = await searchbarService.getSmartInsightSuggestions(
          q,
          selectedCategory.value,
          context.value,
          searchId.value
        )

        insightSuggestions.value = suggestions
      } catch (error) {
        if (!isCancelError(error)) {
          // logger.captureError(error)
        }
      } finally {
        fetchingInsight.value = false
      }
    }

    type SuggestionKind = 'action' | 'autocomplete' | 'classified'
    type NavigableItem = {
      type: SuggestionKind
      column: 'left' | 'right'
      sectionIndex: number
      index: number
      suggestion: any
    }

    const navigableItems = computed<NavigableItem[]>(() => {
      const items: NavigableItem[] = []
      leftColumnSections.value.forEach((section, sectionIdx) => {
        if (section.type === 'insight') {
          return
        }
        section.suggestions.forEach((sugg, idx) => {
          items.push({
            type: section.type as SuggestionKind,
            column: 'left',
            sectionIndex: sectionIdx,
            index: idx,
            suggestion: sugg
          })
        })
      })

      rightColumnSections.value.forEach((section, sectionIdx) => {
        if (section.type === 'insight') {
          return
        }
        section.suggestions.forEach((sugg, idx) => {
          items.push({
            type: section.type as SuggestionKind,
            column: 'right',
            sectionIndex: sectionIdx,
            index: idx,
            suggestion: sugg
          })
        })
      })

      return items
    })

    const setActiveFromIndex = (idx: number) => {
      if (idx < 0 || idx >= navigableItems.value.length) {
        activeSuggestion.value = null
        return
      }
      const item = navigableItems.value[idx]
      activeSuggestion.value = Object.assign({}, item.suggestion, {
        type: item.type
      })
    }

    const flatIndexFor = (
      column: 'left' | 'right',
      sectionIdx: number,
      rowIdx: number
    ): number => {
      return navigableItems.value.findIndex(
        it =>
          it.column === column &&
          it.sectionIndex === sectionIdx &&
          it.index === rowIdx
      )
    }

    const getSectionActiveIndex = (
      column: 'left' | 'right',
      sectionIdx: number
    ): number => {
      if (activeSuggestionIndex.value < 0) {
        return -1
      }
      const item = navigableItems.value[activeSuggestionIndex.value]
      if (!item) return -1
      if (item.column !== column || item.sectionIndex !== sectionIdx) return -1
      return item.index
    }

    const getSectionHoveredIndex = (
      column: 'left' | 'right',
      sectionIdx: number
    ): number => {
      if (hoveredSuggestion.value < 0 || activeSuggestionIndex.value > -1) {
        return -1
      }
      const item = navigableItems.value[hoveredSuggestion.value]
      if (!item) return -1
      if (item.column !== column || item.sectionIndex !== sectionIdx) return -1
      return item.index
    }

    const onSectionRowHover = (
      column: 'left' | 'right',
      sectionIdx: number,
      rowIdx: number
    ) => {
      const idx = flatIndexFor(column, sectionIdx, rowIdx)
      if (idx > -1 && activeSuggestionIndex.value !== idx) {
        activeSuggestionIndex.value = -1
        hoveredSuggestion.value = idx
      }
    }

    const onDown = (e: KeyboardEvent) => {
      e.preventDefault()
      if (!navigableItems.value.length) {
        return
      }

      if (hoveredSuggestion.value > -1) {
        activeSuggestionIndex.value = hoveredSuggestion.value + 1
        hoveredSuggestion.value = -1
      } else {
        activeSuggestionIndex.value++
      }

      if (activeSuggestionIndex.value > navigableItems.value.length - 1) {
        activeSuggestionIndex.value = -1
        activeQ.value = (searchQ.value || '') as string
        activeDisplayPhrase.value = (searchQ.value || '') as string
        activeSuggestion.value = null
      } else {
        setActiveFromIndex(activeSuggestionIndex.value)
        scrollActiveIntoView()
      }
    }
    const onUp = (e: KeyboardEvent) => {
      e.preventDefault()
      if (!navigableItems.value.length) {
        return
      }

      if (hoveredSuggestion.value > -1) {
        activeSuggestionIndex.value = hoveredSuggestion.value - 1
        hoveredSuggestion.value = -1
      } else {
        activeSuggestionIndex.value--
      }

      if (activeSuggestionIndex.value === -1) {
        activeQ.value = (searchQ.value || '') as string
        activeDisplayPhrase.value = (searchQ.value || '') as string
        activeSuggestion.value = null
      } else if (activeSuggestionIndex.value < -1) {
        activeSuggestionIndex.value = navigableItems.value.length - 1
        setActiveFromIndex(activeSuggestionIndex.value)
        scrollActiveIntoView()
      } else {
        setActiveFromIndex(activeSuggestionIndex.value)
        scrollActiveIntoView()
      }
    }

    const scrollActiveIntoView = () => {
      if (activeSuggestionIndex.value < 0) return
      const active = navigableItems.value[activeSuggestionIndex.value]
      if (!active) return

      const container = overflowContainerRef.value as HTMLElement
      if (!container) return

      // try to resolve the row element from section refs
      let rowEl: HTMLElement | null = null
      if (active.column === 'right') {
        const sectionCmp = rightColumnRefs.value[active.sectionIndex]
        if (sectionCmp && sectionCmp.getRowElementAtIndex) {
          rowEl = sectionCmp.getRowElementAtIndex(active.index)
        }
      } else {
        const sectionCmp = leftColumnRefs.value[active.sectionIndex]
        if (sectionCmp && sectionCmp.getRowElementAtIndex) {
          rowEl = sectionCmp.getRowElementAtIndex(active.index)
        }
      }

      if (!rowEl) return

      const overflow = elementIsOverflownInParent(rowEl, container)
      if (overflow) {
        const offset = overflow === 'down' ? 16 : 0
        scrollService.scrollTo(rowEl, {
          container,
          offset,
          easing: 'ease-out',
          duration: 100,
          x: false,
          y: true
        })
      }
    }

    const blurSearchbar = async () => {
      await nextTick()
      if (searchbarRef.value) {
        searchbarRef.value.blur()
      }
    }
    const onKeydown = (e: KeyboardEvent) => {
      if (!showResults.value) {
        return
      }

      const key = e.keyCode

      switch (key) {
        case KeyCode.DOWN:
          onDown(e)
          break
        case KeyCode.UP:
          onUp(e)
          break
        case KeyCode.ESC:
          e.preventDefault()
          closeSuggestions()
          blurSearchbar()
          break
      }
    }

    const onBlur = () => {
      focused.value = false
    }

    const onWindowBlur = () => {
      if (showResults.value) {
        dontFetchNextFocus.value = true // cause we already have the results ready
      }
    }

    const onFocus = () => {
      focused.value = true

      if (dontFetchNextInput.value) {
        dontFetchNextInput.value = false
      }

      if (dontFetchNextFocus.value) {
        dontFetchNextFocus.value = false
        return
      }

      // if it is mobile, show suggestions as modal
      if (isMobile.value) {
        fullscreen.value = true
        modalToggleFunc.modalOpen()

        if (suggestionsRef.value) {
          suggestionsRef.value.scrollTop = 0
        }
      }
      fetchSuggestions(activeQ.value)
    }

    const onClick = () => {
      if (!isMobile.value && silentlyFocused.value && !showResults.value) {
        silentlyFocused.value = false
        onFocus()
      }
    }

    const silentFocus = () => {
      dontFetchNextFocus.value = true
      silentlyFocused.value = true
      focusSearchbar()
    }

    const clearQ = () => {
      closeSuggestions()
      activeQ.value = ''
      activeDisplayPhrase.value = ''
      if (!isMobile.value) {
        dontFetchNextFocus.value = true
      }
      focusSearchbar()
    }

    const showInCategory = computed(() => {
      if (props.notInSearch) {
        return false
      }
      return !classifiedSearchGetters('inRootCategory')
    })

    const updateActiveQFromUrl = async (path: string = '') => {
      await nextTick()
      const pathToUse = path || window.location.search
      const { activeq, q } = qs.parse(pathToUse, {
        ignoreQueryPrefix: true
      })
      if (activeq || q) {
        activeQ.value = activeq || q
      }

      if (activeQ.value) {
        searchQ.value = activeQ.value
        activeDisplayPhrase.value = activeQ.value
      }
    }

    const onGlobalKeyDown = (e: KeyboardEvent) => {
      const key = e.keyCode
      if (key === KeyCode.SLASH) {
        const focusElem = document.activeElement
        const elemType = focusElem.type
        if (
          focusElem.tagName.toLowerCase() === 'input' &&
          [
            'text',
            'search',
            'email',
            'number',
            'password',
            'tel',
            'url'
          ].includes(elemType)
        ) {
          // focus is on an input text element
          return
        }
        e.preventDefault()
        focusSearchbar()
        window.scrollTo(0, 0)
      }
    }

    const addGlobalKeyDownListener = () => {
      document.addEventListener('keydown', onGlobalKeyDown)
      window.addEventListener('blur', onWindowBlur)
    }

    const removeGlobalKeyDownListener = () => {
      document.removeEventListener('keydown', onGlobalKeyDown)
      window.removeEventListener('blur', onWindowBlur)
    }

    const nextActivePlaceholder = () => {
      if (focused.value && !silentlyFocused.value) {
        return
      }
      fadePlaceholder.value = true
      setTimeout(() => {
        if (activePlaceholder.value + 1 > placeholders.value.length - 1) {
          activePlaceholder.value = 0
        } else {
          activePlaceholder.value++
        }
        fadePlaceholder.value = false
      }, 300) // 300 = same as the declared css transition time
    }

    const placeholdersCheck = async () => {
      // reset in case they are already set
      activePlaceholder.value = 0
      clearInterval(placeholderInterval.value)

      await nextTick()
      if (placeholders.value.length > 1) {
        const delay = 4000
        placeholderInterval.value = setInterval(nextActivePlaceholder, delay)
      }
    }

    const afterModalClose = async () => {
      blurSearchbar()
      if (linkToNavigate.value) {
        const link = linkToNavigate.value
        linkToNavigate.value = ''

        await navigateToFinalUrl(link)

        updateActiveQFromUrl(link)
      }

      if (
        classifiedIndexToNavigate.value > -1 &&
        rightColumnIndexToNavigate.value > -1
      ) {
        const rIndex = rightColumnIndexToNavigate.value
        const clsfdIndex = classifiedIndexToNavigate.value
        const clsfdEvent = classifiedClickEvent.value

        rightColumnIndexToNavigate.value = -1
        classifiedIndexToNavigate.value = -1
        classifiedClickEvent.value = null

        if (clsfdIndex > -1 && rIndex > -1) {
          triggerClassifiedAtIndex(rIndex, clsfdIndex, clsfdEvent)
        }
      }
    }

    const disableFullscreen = () => {
      modalToggleFunc.modalClose(false)
    }

    const mobileBackClicked = () => {
      disableFullscreen()
      closeSuggestions()
    }

    const onModalClose = () => {
      fullscreen.value = false
      focused.value = false
    }

    const getUrlWithActiveQ = (path: string) => {
      const fullUrl = new URL(path, window.location.origin)

      if (activeQ.value) {
        fullUrl.searchParams.set('activeq', activeQ.value)
      } else {
        fullUrl.searchParams.delete('activeq')
      }

      return fullUrl.pathname + fullUrl.search
    }

    const goToUrl = async (url: string, addActiveQ = false) => {
      if (!url) {
        return
      }

      let finalUrl = url
      if (addActiveQ) {
        finalUrl = getUrlWithActiveQ(url)
      }

      if (fullscreen.value) {
        closeSuggestions()
        linkToNavigate.value = finalUrl
        blurSearchbar()
        disableFullscreen()
      } else {
        blurSearchbar()
        if (isMobile.value) {
          disableFullscreen()
        }

        await navigateToFinalUrl(finalUrl)
      }
    }

    const navigateToFinalUrl = async (finalUrl: string) => {
      if (!finalUrl) {
        return
      }

      closeSuggestions()

      if (finalUrl.startsWith('http')) {
        externalLinkMediatorUrl.value = finalUrl
      } else if (finalUrl.startsWith('/classifieds/new')) {
        window.location.href = finalUrl
      } else if (inSearchRoute.value) {
        await classifiedSearchDispatch('loadSeoUrlSearch', {
          seoUrl: finalUrl,
          allowDeprecatedLocationParams: true
        })
        if (suggestAfterFetch.value) {
          // stop showing the spinner
          suggestAfterFetch.value = false
        }
      } else {
        suggestAfterFetch.value = true // to show the spinner
        await router
          .push({
            path: finalUrl
          })
          .catch(_e => {})
        suggestAfterFetch.value = false
      }
    }

    const onAutocompletionClick = (completion: SmartAutocompletion) => {
      activeQ.value = completion.query
      searchQ.value = activeQ.value
      activeDisplayPhrase.value = activeQ.value

      // await closeSuggestions()
      fetchSuggestions(searchQ.value)
    }

    const onActionClick = (action: SmartAction) => {
      if (action.url) {
        goToUrl(action.url)
      }
    }

    const onClassifiedClick = (
      rightColumnIndex: number,
      indexAndEvent: { index: number; event: Event }
    ) => {
      const { index, event } = indexAndEvent
      if (fullscreen.value) {
        rightColumnIndexToNavigate.value = rightColumnIndex
        classifiedIndexToNavigate.value = index
        classifiedClickEvent.value = index
        blurSearchbar()
        disableFullscreen()
        closeSuggestions()
      } else {
        triggerClassifiedAtIndex(rightColumnIndex, index, event)
      }
    }
    const triggerClassifiedAtIndex = (
      rightColumnIndex: number,
      index: number,
      event?: Event
    ) => {
      if (rightColumnRefs.value[rightColumnIndex]) {
        rightColumnRefs.value[rightColumnIndex].triggerClassifiedAtIndex(
          index,
          event
        )
      }
    }

    const fetchBackendPlaceholders = async () => {
      try {
        const {
          placeholders: fetchedPlaceholders
        } = await searchbarService.getSmartSearchbarPlaceholders()
        backendPlaceholders.value = fetchedPlaceholders

        placeholdersCheck()
      } catch (_e) {}
    }

    const showOverlay = computed(() => {
      if (fullscreen.value || props.notInSearch) {
        return false
      }
      return showResults.value || focused.value
    })

    const roundedClass = computed(() => {
      if (fullscreen.value && showInCategory.value) {
        return ''
      }
      return props.notInSearch ? 'tw-rounded-xl' : 'tw-rounded-lg'
    })

    const unsubscribe = store.subscribeAction(mutation => {
      if (mutation.type === `${CLASSIFIED_SEARCH_NS}/${CLEAR_ALL}`) {
        closeSuggestions()
        activeQ.value = ''
        searchQ.value = ''
        activeDisplayPhrase.value = ''
      }
    })

    function onMountedCalls() {
      cache.reset()
      updateActiveQFromUrl()
      // fetchBackendPlaceholders()  // re-enable this if we want dynamic backend placeholders

      if (!isMobile.value) {
        addGlobalKeyDownListener()
      }
    }

    onMounted(() => {
      onMountedCalls()

      modalToggleFunc.setModalInSearch(!props.notInSearch)
      modalToggleFunc.setHash('searchbar')
      modalToggleFunc.setAfterModalCloseCallback(afterModalClose)
      modalToggleFunc.setOnModalCloseCallback(onModalClose)

      if (searchbarRef.value === document.activeElement) {
        onFocus()
      }
    })

    function onBeforeUnmountCalls() {
      unsubscribe()
      cache.reset()
      removeGlobalKeyDownListener()
      clearInterval(placeholderInterval.value)
    }

    onBeforeUnmount(() => {
      onBeforeUnmountCalls()
    })

    const hasLeftColumn = computed(() => {
      return Boolean(
        leftColumnSections.value.length &&
          leftColumnSections.value.some(
            ls => ls.suggestions.length || ls.fetching
          )
      )
    })
    const hasRightColumn = computed(() => {
      return Boolean(
        rightColumnSections.value.length &&
          rightColumnSections.value.some(
            rs => rs.suggestions.length || (activeQ.value === '' && rs.fetching) // only show loading on empty query
          )
      )
    })

    watch(
      qFacet,
      newVal => {
        if (newVal?.values) {
          activeQ.value = newVal.values.value || ''
          searchQ.value = activeQ.value
          activeDisplayPhrase.value = activeQ.value
        }
      },
      {
        immediate: true
      }
    )

    watch(inCategory, _newVal => {
      closeSuggestions()
      focusSearchbar()
    })

    watch(route, (to, from) => {
      // we do this because classified search has keep-alive
      const searchRouteName = '__classifieds_search'
      if (
        from.name.startsWith(searchRouteName) &&
        !to.name.startsWith(searchRouteName)
      ) {
        // we are leaving search clientSide
        onBeforeUnmountCalls()
      } else if (
        to.name.startsWith(searchRouteName) &&
        from &&
        !from.name.startsWith(searchRouteName)
      ) {
        // we are entering search clientSide
        onBeforeMountCalls()
        onMountedCalls()
      }
    })

    return {
      clickedOutside,
      hasMic,
      searchbarRef,
      suggestionsRef,
      overflowContainerRef,
      focused,
      focusSearchbar,
      hasLeftColumn,
      onEnter,
      activeQ,
      searchQ,
      fadePlaceholder,
      placeholderToShow,
      selectedCategory,
      onInput,
      micRecording,
      activeSuggestionIndex,
      setFinalQuote,
      setInterimQuote,
      setMicRecStatus,
      onKeydown,
      fetching,
      fullscreen,
      onBlur,
      onFocus,
      onClick,
      clearQ,
      silentFocus,
      showResults,
      isMobile,
      autocompleteSuggestions,
      actionSuggestions,
      classifiedSuggestions,
      insightSuggestions,
      onActionClick,
      mobileBackClicked,
      disableFullscreen,
      onAutocompletionClick,
      leftColumnRefs,
      rightColumnRefs,
      onClassifiedClick,
      leftColumnSections,
      rightColumnSections,
      backendPlaceholders,
      placeholders,
      inCategory,
      showInCategory,
      currentCategoryId,
      showOverlay,
      roundedClass,
      context,
      suggestAfterFetch,
      fetchBackendPlaceholders,
      ciMagnifyingGlass,
      ciAngleLeft,
      ciTimes,
      hasRightColumn,
      externalLinkMediatorUrl,
      getSectionActiveIndex,
      getSectionHoveredIndex,
      onSectionRowHover
    }
  },
  i18n: defineComponentTranslations({
    what_property_looking_for: {
      en: 'What property are you looking for?',
      el: 'Τι ακίνητο ψάχνεις;'
    },
    no_results_for_this_term: {
      en: 'No results found',
      el: 'Δεν βρέθηκαν αποτελέσματα'
    }
  })
})
